// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__33G8g","vLegacy":"SelectSecondary_vLegacy__3xFrx","error":"SelectSecondary_error__2QPgm","disabled":"SelectSecondary_disabled__1vPOj"};